import { Autocomplete } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Form, Formik, FormikErrors } from "formik";
import * as React from "react";
import ButtonGroup from "../../components/Buttons/ButtonGroup";
import ErrorMsg from "../../components/ErrorMsg";
import ProgressIndicator from "../../components/ProgressIndicator";
import strings from "../../config/localization";
import {
  useGetAllDesignationsQuery,
  useNewPersonnelAssessmentMutation,
} from "../../services/appln";

interface FormData {
  designationId: string;
  count: string;
}

interface Props {
  onSubmitHandler: (newObj: any) => void;
  onCancelHandler: () => void;
  state: boolean;
  bandobastId: string;
  timeslotId: string;
  locationId: string;
}

export default function NewPersonnelAssessment(props: Props) {
  const [createPersonnelAssessment, createPersonnelAssessmentParams] =
    useNewPersonnelAssessmentMutation();

  const designationData = useGetAllDesignationsQuery({
    page: 1,
    limt: 1000,
    search: "",
  });
  const designationMap = new Map<string, string>();
  designationData.data?.data.forEach((element: any) => {
    designationMap.set(element.name, element.id);
  });

  const iv: FormData = {
    designationId: "",
    count: "",
  };

  const onCancelHandlerWrapper = () => {
    createPersonnelAssessmentParams.reset();
    props.onCancelHandler();
  };

  console.log(
    "NewPersonnelAssessment, createPersonnelAssessmentParams:",
    createPersonnelAssessmentParams,
  );
  React.useEffect(() => {
    if (createPersonnelAssessmentParams.isSuccess) {
      props.onSubmitHandler(createPersonnelAssessmentParams.data.id);
    }
  }, [createPersonnelAssessmentParams]);

  return (
    <div>
      <Dialog
        open={props.state}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {strings.newPersonnelAssessment}
        </DialogTitle>
        {createPersonnelAssessmentParams.isError && (
          <ErrorMsg msg={strings.failedToCreatePersonnelAssessment} />
        )}
        {createPersonnelAssessmentParams.isLoading && <ProgressIndicator />}
        <DialogContent>
          <Formik
            initialValues={iv}
            validate={(values) => {
              const errors: FormikErrors<FormData> = {};
              if (!values.designationId) {
                errors.designationId = strings.designationMandatory;
              }
              if (!values.count) {
                errors.count = strings.countMandatory;
              } else {
                const countVal = parseInt(values.count);
                if (isNaN(countVal)) {
                  errors.count = strings.countShouldBeNumber;
                }
              }
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              const valuesClone = { ...values };
              valuesClone.designationId = designationMap.get(
                values.designationId!,
              )!;
              console.log(
                "NewPersonnelAssessment, values after modification",
                valuesClone,
              );
              setSubmitting(false);
              createPersonnelAssessment({
                bandobastId: props.bandobastId,
                timeslotId: props.timeslotId,
                locationId: props.locationId,
                body: valuesClone,
              });
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={9}>
                      <Autocomplete
                        fullWidth
                        disablePortal
                        id="designationId"
                        options={Array.from(designationMap.keys())}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            margin="normal"
                            required
                            label={strings.designation}
                            error={
                              touched.designationId &&
                              Boolean(errors.designationId)
                            }
                          />
                        )}
                        onChange={(e, value: any) => {
                          setFieldValue("designationId", value);
                        }}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      <TextField
                        fullWidth
                        required
                        margin="normal"
                        id="count"
                        name="count"
                        label={strings.count}
                        value={values.count}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.count && Boolean(errors.count)}
                        helperText={touched.count && errors.count}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <ButtonGroup>
                        <Button
                          variant="contained"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {strings.create}
                        </Button>
                        <Button
                          variant="contained"
                          onClick={onCancelHandlerWrapper}
                        >
                          {strings.cancel}
                        </Button>
                      </ButtonGroup>
                    </Grid>
                  </Grid>
                </Box>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </div>
  );
}
